import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import ResponsiveHeader from "../reusble_components/labels3/responsiveHeader";
import { useState, useEffect } from "react";
import { getUserDetailsFromLocalStorage } from "../../services/reusable";

export default function DashboardHeader() {
  const { PopupStore } = useStores();
  const navigate = useNavigate();
  const [accessTypeStatus, setAccessTypeStatus] = useState("unrestricted");

  //Access Type
  const accessType = async () => {
    const user = await getUserDetailsFromLocalStorage();
    console.log(user, "user");
    if (user?.access) {
      console.log(user?.access[0]?.accessType, "user?.access[0]?.accessType");
      const status =
        user?.access[0]?.accessType === "6971bb50ce17d9413a277db4"
          ? "restricted"
          : "unrestricted";
      console.log(status, "status11");
      return status;
    }
    return "unrestricted";
  };

  useEffect(() => {
    const fetchAccessType = async () => {
      const access = await accessType();
      console.log(access, "access");
      setAccessTypeStatus(access);
    };
    fetchAccessType();
  }, []);

  return useObserver(() => (
    <>
      {/* <div className="flex flex-row justify-between items-center h-10 w-full bg-white  mb-5 px-4 md:px-8 lg:px-16">
        <h1 className="text-primary font-semibold text-2xl">Dashboard</h1>
        <div className="flex flex-row  gap-10 min-w-96  items-center">
          <div
            // onClick={() => notify()}
            className="flex bg-[#f1f1f1] md:items-center md:justify-center lg:w-[7%] md:h-12 md:w-12 lg:h-14 rounded-2xl lg:rounded-3XL cursor-pointer "
          >
            <Tooltip
              id="notificationbtntooltip"
              position="bottom"
              content="Notifications"
            >
              <MdOutlineNotifications
                onClick={() => {
                  PopupStore.setNotification(true);
                }}
                className="w-8 h-8 hidden md:block "
              />
            </Tooltip>
          </div>
          <div
            className="flex bg-primary gap-2 justify-center items-center  md:text-xl lg:text-xl text-lg  whitespace-nowrap   rounded-xl text-white cursor-pointer py-2 px-5"
            onClick={() => {
              navigate("/company/services");
            }}
          >
            <MdOutlineAddCircleOutline className="text-2xl" />
            Create New
          </div>
        </div>
      </div> */}
      <ResponsiveHeader
        onClickButton={() => {
          if (accessTypeStatus === "restricted") {
            return;
          }
          navigate("/company/services");
        }}
        title={"Dashboard"}
        showSearch={false}
        buttonLable="Create New"
        showDropdown={false}
      />
    </>
  ));
}
